import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
@Component({
  selector: "app-vces-callback",
  templateUrl: "./vces-callback.component.html",
  styleUrls: ["./vces-callback.component.scss"],
})
export class VCESCallbackComponent implements OnInit {
  constructor(private router: Router) {}
  ngOnInit(): void {
    document.getElementsByTagName("footer")[0].style.display = "none";
    if (window.top["validateToken"]) {
      window.top["validateToken"]();
    } else {
      this.router.navigate([""], {
        queryParams: { isVCESRedirect: true },
        queryParamsHandling: ""
      });
    }
  }
}
